// extracted by mini-css-extract-plugin
module.exports = {"oddStatus":"betslip-error_oddStatus__GJmIF","suspended":"betslip-error_suspended__edoyW"};